import axios from "axios";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { loginApi, registerApi } from "../api/Urls";
import Cookie from "js-cookie";
import { SIGNIN_USER, SIGNOUT_USER, SIGNUP_USER } from "constants/ActionTypes";
import {
  showAuthMessage,
  showAuthMessageSuccess,
  userSignInSuccess,
  userSignUpSuccess,
  userSignInVerification,
  hideMessage,
} from "actions/Auth";
import { createBrowserHistory } from "history";

console.log("log", window);
const { Wazo } = window["@wazo/sdk"];
Wazo.Auth.init("webrtc-demo");
const history = createBrowserHistory();

const createUserWithEmailPasswordRequest = async (payload) => {
  const {
    first_name,
    last_name,
    email,
    phone,
    password,
    merchant_code,
    are_guideline_accepted,
  } = payload;

  let finalData = new FormData();
  finalData.append("email", email);
  finalData.append("phone", phone);
  finalData.append("password", password);
  finalData.append("first_name", first_name);
  finalData.append("last_name", last_name);
  finalData.append("merchant_code", merchant_code);
  finalData.append("are_guidelines_accepted", are_guideline_accepted);

  return await axios.post(registerApi, finalData, {
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=<calculated when request is sent>",
    },
  });
};

const signInUserWithEmailPasswordRequest = async (email, password) => {
  let finalData = new FormData();
  finalData.append("email", email);
  finalData.append("password", password);
  return await axios.post(loginApi, finalData, {
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=<calculated when request is sent>",
    },
  });
};

function* createUserWithEmailPassword({ payload }) {
  try {
    const signUpUser = yield call(createUserWithEmailPasswordRequest, payload);
    if (signUpUser.status === 201) {
      yield put(userSignUpSuccess(payload.email));
      yield put(showAuthMessageSuccess(signUpUser.data.message));
      const tour = {
        users: true,
        groups: true,
        userInGroup: true,
        userGroups: true,
        dispatch: true,
        notifications: true,
        missions: true,
      };
      localStorage.setItem("isTour", JSON.stringify(tour));
      const dispatchSettings = {
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
      };
      localStorage.setItem(
        "dispatchSettings",
        JSON.stringify(dispatchSettings)
      );

      // test start
      try {
        const res = yield call(
          signInUserWithEmailPasswordRequest,
          payload.email,
          payload.password
        );
        if (res.status === 200) {
          yield put(
            userSignInSuccess({
              authUser: res.data.username,
              uuid: res.data.uuid,
            })
          );
          yield put(
            userSignInVerification({
              email: res.data.is_email_verified,
              phone: res.data.is_phone_verified,
              phoneNumber: res.data.phone,
            })
          );
          yield put(showAuthMessageSuccess(res.data.message));
          Cookie.set("token", res.data.token);
          localStorage.setItem("user_id", res.data.username);
          localStorage.setItem("firstname", res.data.firstname);
          localStorage.setItem("lastname", res.data.lastname);
          localStorage.setItem("uuid", res.data.uuid);
          localStorage.setItem("reseller", res.data.is_reseller);
          localStorage.setItem("phone", res.data.phone);
          localStorage.setItem("isPhoneVerified", res.data.is_phone_verified);
          localStorage.setItem("isEmailVerified", res.data.is_email_verified);
          setTourData();
          setDispatchSettingData();
          const setSessionOnStorage = (session) => {
            localStorage.setItem("session", JSON.stringify(session));
          };

          const hostLogin = async () => {
            try {
              Wazo.Auth.setHost(res.data.voice.hostname);
              let session = await Wazo.Auth.logIn(
                res.data.voice.username,
                res.data.voice.password
              ).catch();
              // Useful to retrieve the server from localstorage
              session.server = res.data.voice.hostname;
              setSessionOnStorage(session);
            } catch (e) {
              console.log(e);
            }
          };

          hostLogin();
          history.push("/");
        }
      } catch (error) {
        yield put(showAuthMessage(error.response.data.message));
        yield put(hideMessage());
      }
      // test end
    }
    window.location.replace("/phone-verification");
  } catch (error) {
    yield put(
      showAuthMessage(
        error?.response?.status === 500
          ? error?.response?.statusText
          : error?.response?.data?.message
          ? error?.response?.data?.message
          : error?.response?.data?.password
      )
    );
    yield put(hideMessage());
  }
}

function* signInUserWithEmailPassword({ payload }) {
  const { email, password } = payload;
  try {
    const res = yield call(signInUserWithEmailPasswordRequest, email, password);

    if (res.status === 200) {
      yield put(
        userSignInSuccess({
          authUser: res.data.username,
          uuid: res.data.uuid,
        })
      );
      yield put(
        userSignInVerification({
          email: res.data.is_email_verified,
          phone: res.data.is_phone_verified,
          phoneNumber: res.data.phone,
        })
      );
      yield put(showAuthMessageSuccess(res.data.message));
      Cookie.set("token", res.data.token);
      localStorage.setItem("user_id", email);
      localStorage.setItem("firstname", res.data.firstname);
      localStorage.setItem("lastname", res.data.lastname);
      localStorage.setItem("uuid", res.data.uuid);
      localStorage.setItem("reseller", res.data.is_reseller);
      localStorage.setItem("phone", res.data.phone);
      localStorage.setItem("isPhoneVerified", res.data.is_phone_verified);
      localStorage.setItem("isEmailVerified", res.data.is_email_verified);
      setTourData();
      setDispatchSettingData();
      const setSessionOnStorage = (session) => {
        localStorage.setItem("session", JSON.stringify(session));
      };

      const hostLogin = async () => {
        try {
          Wazo.Auth.setHost(res.data.voice.hostname);
          let session = await Wazo.Auth.logIn(
            res.data.voice.username,
            res.data.voice.password
          ).catch();
          // Useful to retrieve the server from localstorage
          session.server = res.data.voice.hostname;
          setSessionOnStorage(session);
        } catch (e) {
          console.log("wazo error", e);
        }
      };

      hostLogin();
      history.push("/");
    }
  } catch (error) {
    // yield put(showAuthMessage(error.response.data.message));
    yield put(hideMessage());
  }
}

function* signOut() {
  try {
    localStorage.removeItem("user_id");
    localStorage.removeItem("token");
    localStorage.removeItem("firstname");
    localStorage.removeItem("lastname");
    localStorage.removeItem("uuid");
    window.location.reload(false);
  } catch (error) {}
}

export function* createUserAccount() {
  yield takeEvery(SIGNUP_USER, createUserWithEmailPassword);
}

export function* signInUser() {
  yield takeEvery(SIGNIN_USER, signInUserWithEmailPassword);
}

export function* signOutUser() {
  yield takeEvery(SIGNOUT_USER, signOut);
}

const setTourData = () => {
  const isTour = localStorage.getItem("isTour");
  if (!isTour) {
    const tour = {
      users: true,
      groups: true,
      userInGroup: true,
      userGroups: true,
      dispatch: true,
      notifications: true,
      missions: true,
    };
    localStorage.setItem("isTour", JSON.stringify(tour));
  }
};

const setDispatchSettingData = () => {
  const isDispatchSettings = localStorage.getItem("dispatchSettings");
  if (!isDispatchSettings) {
    const dispatchSettings = {
      0: false,
      1: false,
      2: false,
      3: false,
      4: false,
      5: false,
    };
    localStorage.setItem("dispatchSettings", JSON.stringify(dispatchSettings));
  }
};

export default function* rootSaga() {
  yield all([
    fork(signInUser),
    fork(createUserAccount),
    // fork(signInWithGoogle),
    // fork(signInWithFacebook),
    // fork(signInWithTwitter),
    // fork(signInWithGithub),
    fork(signOutUser),
  ]);
}
